<app-tab-layout [loading]="loading()" [error]="error">
  <ng-template #acceptLeaveButton let-onClick="onClick" let-row="row">
    <button
      [buttonType]="'square'"
      [buttonTheme]="'primary'"
      style="align-self: center"
      (click)="onClick()"
    >
      @if (confirmingLeave()?.row === row.id && confirmingLeave()?.accept) {
        <div class="spinner-wrapper">
          <app-loading-spinner />
        </div>
      }
      <ng-icon size="18" strokeWidth="2" [name]="'check'"></ng-icon>
    </button>
  </ng-template>

  <ng-template #rejectLeaveButton let-onClick="onClick" let-row="row">
    <button
      [buttonType]="'square'"
      [buttonTheme]="'light'"
      style="align-self: center"
      (click)="onClick()"
    >
      @if (confirmingLeave()?.row === row.id && !confirmingLeave()?.accept) {
        <div class="spinner-wrapper">
          <app-loading-spinner />
        </div>
      }
      <ng-icon size="18" strokeWidth="2" [name]="'xmark'"></ng-icon>
    </button>
  </ng-template>

  <app-api-table
    endpoint="/activities/tables/supervisor-pending"
    chartColumn="Name"
    [name]="dictionaryService.get('PendingLeaves')"
    [actionCol]="actionCols"
  >
  </app-api-table>
</app-tab-layout>
